export default __webpack_public_path__ + "static/media/empty_assets.29872306.png";